import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ImageComponent from '../../../atoms/Image';
import FOOTER_DATA from '../Data/SampleData';
import { FooterListComp } from './FooterListComp';
import Accordian from '../../../atoms/Accordian/Accordian';
import { NavItemComp } from '../../../atoms/NavItems/Presentation/NavItemComp';
import { AnchorWithLink } from '../../../atoms/Anchor';
import { SelectOptions } from '../../../atoms/DropDown';
import { modifyData, getAllowedLanguage } from '../FooterUtilities/FooterUtils';
import KFCbucket from '../../../styles/staticAssets/images/KFCbucket.svg';
import { FooterAppButtonsComp } from './FooterAppButtons';
import {
  isEmptyObject,
  getFromLocalStorage,
  getValueOrDefaultAlternativeObject,
  getTernaryValue,
} from '../../../common/utilities/utils';
import { USER_SELECTED_LANGUAGE } from '../../../common/constants/SharedConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import ListItems from './ListItems';
import { useLocation } from 'react-router-dom';
import FOOTER_CONSTANT from '../FooterConstants/FooterConstant';

/**
 * Main Footer Items Component
 * @param {*} props - Object - title
 */
const FooterItems = props => {
  const { contentData = [], clickHandler = null, isMobile = false, tenantReducerData, navigateHandler = null } = props;
  const { bodyContent = {}, footerContent = {} } = modifyData(contentData) || {};
  const location = useLocation();
  const userParams = useSelector(data => data.appStateReducer.userStatus);
  const { INDIA } = FOOTER_CONSTANT;
  const { categories = [], kfcLogo = {}, kfcStoreSearch = {}, downloadAppButtons = {} } = bodyContent;
  let { copyrightContentData = {}, languageDropdown = {}, socialMediaContent = {} } = footerContent;
  const { defaultLanguage, allowedLanguages, COUNTRY } = useSelector(
    ({ tenantReducer: { basic: { allowedLanguages = [], defaultLanguage } = {}, country: COUNTRY = '' } = {} }) => ({
      allowedLanguages,
      defaultLanguage,
      COUNTRY,
    }),
  );
  const [selectedValue, setSelectedValue] = useState();
  const [modifiedCategories, setModifiedCategories] = useState([]);

  useEffect(() => {
    if (categories.length !== 0) {
      setModifiedCategories(categories);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const localStorageLanguage = allowedLanguages.find(
      item => item.key === getFromLocalStorage(`${COUNTRY}_${USER_SELECTED_LANGUAGE}`),
    );
    !!COUNTRY && setSelectedValue((localStorageLanguage || {}).value || (defaultLanguage || {}).value);
  }, [COUNTRY, allowedLanguages, defaultLanguage]);

  // BELOW LINE NEEDS TO BE REMOVED WHEN ACTUAL LANGUAGE DATA WILL START COMING FROM CONTENTFUL
  languageDropdown =
    (tenantReducerData &&
      tenantReducerData.basic &&
      getAllowedLanguage(FOOTER_DATA.contentData.footerContent.languageDropdown, tenantReducerData.basic)) ||
    {};
  const onAccordianclickHandler = e => {
    const accordian = e.target.parentElement.parentElement;
    accordian.classList.contains('footer-accordian-open')
      ? accordian.classList.remove('footer-accordian-open')
      : accordian.classList.add('footer-accordian-open');
  };

  /*  draw category items */
  const categoryItems = () => {
    return modifiedCategories.map((item, ind) => {
      return <FooterListComp key={ind} className='footer-links' onClickHandler={clickHandler} {...item} />;
    });
  };

  /*  draw social media items */
  const socialMediaItems = () => {
    return socialMediaContent.map((item, ind) => {
      return (
        <FooterListComp
          key={ind}
          className='social-icons'
          data-testid='footerItemSocial-component'
          onClickHandler={clickHandler}
          {...item}
        />
      );
    });
  };

  // language dropdown element rendering here
  const langDropDownElmnt = () => {
    return (
      <div className='column lang-div'>
        {isEmptyObject(languageDropdown) && (
          <NavItemComp
            tabIndex='0'
            onClickHandler={clickHandler}
            name={languageDropdown.type || languageDropdown.name || 'cart'}
          >
            <SelectOptions
              tabIndex='-1'
              options={allowedLanguages.map(itemval => itemval?.short_value?.toUpperCase())}
              className='language-select'
              selectedValue={selectedValue}
            />
            <span className='dropdown-img-footer'></span>
          </NavItemComp>
        )}
      </div>
    );
  };

  /* draw mobile view footer */
  const mobileFooter = (
    <footer
      className={`site-footer ${
        !userParams?.localized && location.pathname.startsWith('/') && tenantReducerData?.country === INDIA
          ? 'nonlocalized-footer'
          : 'localized-footer'
      }`}
      data-testid='mobileFooter-component'
    >
      <div className='row mobile-header-logo'>
        <div className='header-logo' onClick={navigateHandler}>
          <ImageComponent
            srcFile={getValueOrDefaultAlternativeObject(kfcLogo.src, KFCbucket)}
            alt={getValueOrDefaultAlternativeObject(kfcLogo.alt, 'KFC LOGO')}
            className='kfc-footer-logo'
          />
        </div>
      </div>
      <div className='row-mobile'>
        {modifiedCategories.map(item => {
          return (
            <Accordian header={item.categoryHeaderText} isDarkMode={true} onClickHandler={onAccordianclickHandler}>
              <ul className='footer-mobile-list' tabIndex='0'>
                {item.subCategories.map((subItem, ind) => {
                  return (
                    <ListItems key={ind} data-testid='listItems-component' onClickHandler={clickHandler} {...subItem}>
                      {subItem.name}
                    </ListItems>
                  );
                })}
              </ul>
            </Accordian>
          );
        })}
      </div>
      <hr></hr>
      <div className='row-mobile'>
        <div className='findstore-mobile'>
          <ImageComponent srcFile={kfcStoreSearch.url} alt={''} />
          <AnchorWithLink
            href={kfcStoreSearch.linkTo}
            name={kfcStoreSearch.name}
            onClickHandler={clickHandler}
            targetWindow='_blank'
            tabIndex='0'
            type={'external'}
          >
            {translateWithI18Next(kfcStoreSearch.name)}
          </AnchorWithLink>
        </div>
      </div>
      <hr class='mobile-horizontal'></hr>
      <div className='row-mobile app-store' data-testid='app-store'>
        <div className='flex'>{translateWithI18Next('downloadApp')}</div>
        <div className='flex social-btns' data-testid='social-btns'>
          <FooterAppButtonsComp buttonContent={downloadAppButtons} />
        </div>
      </div>
      <div className='row row-mobile mobile-language my-2'>
        {langDropDownElmnt()}
        <div className='column social-div'>
          <ul className='social-icons'>{socialMediaItems()}</ul>
        </div>
      </div>
      <div
        className={`row row-mobile row-copyright ${
          location.pathname.includes('pdp') && isMobile ? 'pdp-row-copyright' : ''
        }`}
      >
        <div className='column copyright-mobile'>
          <p className='copyright-text'>{copyrightContentData.name}</p>
        </div>
      </div>
    </footer>
  );

  /*  draw desktop view footer*/
  const desktopFooter = (
    <footer className='site-footer' data-testid='desktopFooter-component'>
      <div className='row row-one aa'>
        <AnchorWithLink
          className='header-logo'
          data-testid='desktopFooter-component-navigate-handler'
          onClickHandler={navigateHandler}
        >
          <ImageComponent
            srcFile={getValueOrDefaultAlternativeObject(kfcLogo.src, KFCbucket)}
            alt={getValueOrDefaultAlternativeObject(kfcLogo.alt, 'KFC LOGO')}
            className='kfc-footer-logo'
          />
        </AnchorWithLink>
        <div className='category-items'>{categoryItems()}</div>
        <div className='findstore'>
          <ImageComponent srcFile={kfcStoreSearch.url} alt={''} />
          <AnchorWithLink
            href={kfcStoreSearch.linkTo}
            onClickHandler={clickHandler}
            name={kfcStoreSearch.name}
            targetWindow='_blank'
            tabIndex='0'
            type={'external'}
          >
            {translateWithI18Next(kfcStoreSearch.name)}
          </AnchorWithLink>
        </div>
        <div className='flex social-btns' data-testid='social-btns'>
          <FooterAppButtonsComp buttonContent={downloadAppButtons} />
        </div>
      </div>

      <div className='row row-two'>
        {langDropDownElmnt()}
        <div className='column'>
          <p className='copyright-text'>{copyrightContentData.name}</p>
        </div>

        <div className='column social-div'>
          <ul className='social-icons'>{socialMediaItems()}</ul>
        </div>
      </div>
    </footer>
  );

  return getTernaryValue(isMobile, mobileFooter, desktopFooter);
};

export { FooterItems };
